import React from "react";

import { SS23 } from "../../../../js/database/database-ss23.js";

import ProductsContainer from "../../../../components/containers/ProductsContainer.js";
import { SwiperSlide } from "swiper/react";

const SleazyNetKnitGreen = () => {
  return (
    <ProductsContainer
      pageTitle={SS23.tops.SleazyNetKnitGreen.itemName}
      name={SS23.tops.SleazyNetKnitGreen.itemName}
      price={SS23.tops.SleazyNetKnitGreen.itemPrice}
      fabric={SS23.tops.SleazyNetKnitGreen.itemFabric}
      src={SS23.tops.SleazyNetKnitGreen.sizeChart}
      divId={SS23.tops.SleazyNetKnitGreen.shopifyDivId}
      mainId={SS23.tops.SleazyNetKnitGreen.shopifyId}
      buttonShouldHide={true}
    >
      {React.Children.toArray(
        SS23.tops.SleazyNetKnitGreen.pictures.map(({ srcJpeg }) => (
          <SwiperSlide>
            <img
              src={srcJpeg}
              alt={SS23.tops.SleazyNetKnitGreen.itemName}
              width={SS23.imgWidth}
              height={SS23.imgHeight}
              loading={SS23.loading}
            />
          </SwiperSlide>
        ))
      )}
    </ProductsContainer>
  );
};

export default SleazyNetKnitGreen;
